import React, { useState, Suspense } from 'react';
import { useLaudos } from '../../hooks/useLaudos';
import Hemograma from './components/Hemograma';
import Imagem from './components/Imagem';
import ECG from './components/ECG';
import TesteErgometrico from './components/TesteErgometrico';
import Endoscopia from './components/Endoscopia';
import Spinner from '../../components/common/Spinner';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Layout from '../../components/layout/Layout';
import { Bars3Icon } from '@heroicons/react/24/outline';
import { useNavigate } from 'react-router-dom'; // Import para navegação

const RaioX = () => <div>Raio X Placeholder</div>;
const Ultrassonografia = () => <div>Ultrassonografia Placeholder</div>;
const RessonanciaMagnetica = () => <div>Ressonância Magnética Placeholder</div>;
const Tomografia = () => <div>Tomografia Placeholder</div>;
const Ecocardiograma = () => <div>Ecocardiograma Placeholder</div>;
const Colposcopia = () => <div>Colposcopia Placeholder</div>;
const Mamografia = () => <div>Mamografia Placeholder</div>;
const Densitometria = () => <div>Densitometria Placeholder</div>;
const Broncoscopia = () => <div>Broncoscopia Placeholder</div>;
const Holter = () => <div>Holter 24h Placeholder</div>;
const Mapa = () => <div>Mapa 24h Placeholder</div>;

const LaudosPage = () => {
  const { selectedLaudo, setSelectedLaudo } = useLaudos();
  const [loading, setLoading] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate(); // Hook para navegação

  const handleSelectLaudo = (laudo) => {
    setLoading(true);
    if (typeof laudo === 'string') {
      setSelectedLaudo(laudo);
      setTimeout(() => {
        setLoading(false);
        toast.success(
          `Laudo de ${laudo.toUpperCase()} selecionado com sucesso!`,
          {
            position: 'top-right',
          }
        );
      }, 1000);
    }
  };

  const laudos = [
    { name: 'Hemograma', component: Hemograma, icon: '🩸' },
    { name: 'Exame de Imagem', component: Imagem, icon: '🖼️' },
    { name: 'Eletrocardiograma (ECG)', component: ECG, icon: '❤️' },
    { name: 'Teste Ergométrico', component: TesteErgometrico, icon: '🏃' },
    { name: 'Endoscopia', component: Endoscopia, icon: '🔬' },
    { name: 'Raio X', component: RaioX, icon: '🦴' },
    { name: 'Ultrassonografia', component: Ultrassonografia, icon: '🧬' },
    {
      name: 'Ressonância Magnética',
      component: RessonanciaMagnetica,
      icon: '🧲',
    },
    { name: 'Tomografia Computadorizada', component: Tomografia, icon: '🖥️' },
    { name: 'Ecocardiograma', component: Ecocardiograma, icon: '💓' },
    { name: 'Colposcopia', component: Colposcopia, icon: '👩‍⚕️' },
    { name: 'Mamografia', component: Mamografia, icon: '👩' },
    { name: 'Densitometria Óssea', component: Densitometria, icon: '🦴' },
    { name: 'Broncoscopia', component: Broncoscopia, icon: '🫁' },
    { name: 'Holter 24h', component: Holter, icon: '⏳' },
    { name: 'Mapa 24h', component: Mapa, icon: '📊' },
  ];

  const convenios = [
    { name: 'Unimed', icon: '🏥' },
    { name: 'Amil', icon: '🏥' },
    { name: 'Bradesco Saúde', icon: '🏥' },
    { name: 'SulAmérica', icon: '🏥' },
    { name: 'Caixa Seguradora Saúde', icon: '🏥' },
    { name: 'Porto Seguro Saúde', icon: '🏥' },
    { name: 'Hapvida', icon: '🏥' },
    { name: 'Allianz Saúde', icon: '🏥' },
  ];

  const handleSelectConvenio = (convenio) => {
    navigate(`/convenios/${convenio.name.toLowerCase()}`); // Navegação dinâmica
    toast.info(`Convênio ${convenio.name} selecionado.`);
  };
  return (
    <Layout>
      <div className="bg-white shadow-lg rounded-2xl">
        <div className="flex justify-between items-center p-4 max-w-screen-xl mx-auto">
          <h1 className="text-2xl font-bold text-primary">
            Laudos, Convênios e TISS
          </h1>
          <button
            className="bg-primary text-white hover:bg-secondary dark:hover:bg-gray-700 rounded-lg p-2 flex items-center space-x-2"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <Bars3Icon className="w-6 h-6" />
            <span>Menu Principal</span>
          </button>
        </div>

        {/* Conditional Dropdown Menu */}
        <div
          className={`${menuOpen ? 'block' : 'hidden'} bg-gray-100 shadow-lg`}
        >
          <div className="grid grid-cols-2 gap-8 p-8">
            {/* Laudos Section */}
            <div>
              <h2 className="font-bold text-lg mb-4 text-primary">Laudos</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {laudos.map((laudo, idx) => (
                  <div
                    key={idx}
                    className="p-4 bg-white shadow-md rounded-lg hover:shadow-xl transition duration-300 cursor-pointer"
                    onClick={() => handleSelectLaudo(laudo.name.toLowerCase())}
                  >
                    <div className="flex items-center space-x-4">
                      <span className="text-3xl">{laudo.icon}</span>
                      <span className="font-semibold text-gray-700">
                        {laudo.name}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Convênios Section */}
            <div>
              <h2 className="font-bold text-lg mb-4 text-primary">Convênios</h2>
              <div className="grid grid-cols-1 gap-4">
                {convenios.map((convenio, idx) => (
                  <div
                    key={idx}
                    className="p-4 bg-white shadow-md rounded-lg hover:shadow-xl transition duration-300 cursor-pointer"
                    onClick={() => handleSelectConvenio(convenio)}
                  >
                    <div className="flex items-center space-x-4">
                      <span className="text-3xl">{convenio.icon}</span>
                      <span className="font-semibold text-gray-700">
                        {convenio.name}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content Area */}
      <div className="p-8">
        {loading ? (
          <div className="flex justify-center items-center h-48">
            <Spinner />
          </div>
        ) : (
          <Suspense fallback={<Spinner />}>
            {selectedLaudo === 'hemograma' && <Hemograma />}
            {selectedLaudo === 'exame de imagem' && <Imagem />}
            {selectedLaudo === 'eletrocardiograma (ecg)' && <ECG />}
            {selectedLaudo === 'teste ergometrico' && <TesteErgometrico />}
            {selectedLaudo === 'endoscopia' && <Endoscopia />}
          </Suspense>
        )}
      </div>
    </Layout>
  );
};

export default LaudosPage;
